import { AuthResponse } from '../types/AuthResponse';
import { buildApiUrl } from '../utils/buildApiUrl';

export async function login(email: string, password: string): Promise<AuthResponse> {
  const res = await fetch(buildApiUrl('/api/users/login'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to login: ${errorText}`);
  }

  return res.json();
}

export async function loginWithGoogle(credential: string): Promise<AuthResponse> {
  const url = buildApiUrl('/api/users/google-login');
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to login with Google: ${errorText}`);
  }

  return res.json();
}
